import { useReducer } from 'react'
import { TasksContext, TasksContextDispatch } from './tasks-context'
import { TasksContextReducer, initialState } from './tasks-context-reducer'

export const TasksContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(TasksContextReducer, initialState)

  return (
    <TasksContext.Provider value={state}>
      <TasksContextDispatch.Provider value={dispatch}>
        {children}
      </TasksContextDispatch.Provider>
    </TasksContext.Provider>
  )
}
